import MediumEditor from 'medium-editor';

var Pie = MediumEditor.extensions.form.extend({
    
    name: 'pie',
    action: 'footer',
    aria: 'select footer',
    title: 'Seleccionar pie',
    contentDefault: '&#xB1;', // ±
    f7Icon: 'square_arrow_down',

    pies: [],

    init: function () {
        this.button = this.document.createElement('button');
        this.button.classList.add('medium-editor-action');
        this.button.innerHTML = '<i class="icons f7-icons">' + this.f7Icon + '</i>';
        this.button.title = this.title;
        this.on(this.button, 'click', this.handleClick.bind(this));
    },

    // Called when the button the toolbar is clicked
    // Overrides ButtonExtension.handleClick
    handleClick: function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.showForm();

        return false;
    },

    // Called by medium-editor to append form to the toolbar
    getForm: function () {
        if (!this.form) {
            this.form = this.createForm();
        }
        return this.form;
    },

    // Used by medium-editor when the default toolbar is to be displayed
    isDisplayed: function () {
        return this.getForm().style.display === 'block';
    },

    hideForm: function () {
        this.getForm().style.display = 'none';
        this.getSelect().value = '';
    },

    showForm: function () {
        var select = this.getSelect();

        this.base.saveSelection();
        this.hideToolbarDefaultActions();
        this.getForm().style.display = 'block';
        this.setToolbarPosition();

        select.focus();
    },

    // Called by core when tearing down medium-editor (destroy)
    destroy: function () {
        if (!this.form) {
            return false;
        }

        if (this.form.parentNode) {
            this.form.parentNode.removeChild(this.form);
        }

        delete this.form;
    },

    // core methods

    doFormSave: function () {
        this.base.restoreSelection();
        this.base.checkSelection();
    },

    doFormCancel: function () {
        this.base.restoreSelection();
        this.base.checkSelection();
    },

    // form creation and event handling
    createForm: function () {
        var doc = this.document,
            form = doc.createElement('div'),
            select = doc.createElement('select'),
            close = doc.createElement('a'),
            save = doc.createElement('a'),
            option;

        // Font Name Form (div)
        form.className = 'medium-editor-toolbar-form';
        form.id = 'medium-editor-toolbar-form-fontname-' + this.getEditorId();

        // Handle clicks on the form itself
        this.on(form, 'click', this.handleFormClick.bind(this));

        // Add font names
        for (var i = 0; i<this.pies.length; i++) {
            option = doc.createElement('option');
            option.innerHTML = this.pies[i].name;
            option.value = this.pies[i].content;
            select.appendChild(option);
        }

        select.className = 'medium-editor-toolbar-select';
        form.appendChild(select);

        // Handle typing in the textbox
        this.on(select, 'change', this.handleFooterChange.bind(this));

        // Add save buton
        save.setAttribute('href', '#');
        save.className = 'medium-editor-toobar-save';
        save.innerHTML = this.getEditorOption('buttonLabels') === 'fontawesome' ?
                            '<i class="fa fa-check"></i>' :
                            '&#10003;';
        form.appendChild(save);

        // Handle save button clicks (capture)
        this.on(save, 'click', this.handleSaveClick.bind(this), true);

        // Add close button
        close.setAttribute('href', '#');
        close.className = 'medium-editor-toobar-close';
        close.innerHTML = this.getEditorOption('buttonLabels') === 'fontawesome' ?
                            '<i class="fa fa-times"></i>' :
                            '&times;';
        form.appendChild(close);

        // Handle close button clicks
        this.on(close, 'click', this.handleCloseClick.bind(this));

        return form;
    },

    getSelect: function () {
        return this.getForm().querySelector('select.medium-editor-toolbar-select');
    },

    handleFooterChange: function () {
        var contenedor = this.base.elements[0].getElementsByClassName("footer-content")[0];

        var templatePie = this.getSelect().value;
        console.log('Aplicando pie de página:', templatePie);
        console.log('Tipo de templatePie:', typeof templatePie);
        
        // Si viene "undefined" como string, convertirlo a string vacío
        if (templatePie === 'undefined' || templatePie === undefined) {
            templatePie = '';
        }
        
        contenedor.innerHTML = templatePie;
        this._gestionarClaseNoFooter(contenedor);
        this._gestionarMargen(contenedor);
        
        console.log('Footer contenido final:', contenedor.innerHTML);
        console.log('Footer clases:', contenedor.className);
    },

    _gestionarClaseNoFooter: function(contenedorFooter){
        var content = contenedorFooter.innerHTML;
        console.log('Gestionando clase no-footer, contenido:', content);
        
        if(content === '' || content === 'undefined' || content === undefined){
            console.log('Footer vacío, añadiendo clase no-footer');
            contenedorFooter.classList.add("no-footer");
        } else {
            console.log('Footer con contenido, removiendo clase no-footer');
            contenedorFooter.classList.remove("no-footer");
        }
    },

    handleFormClick: function (event) {
        // make sure not to hide form when clicking inside the form
        event.stopPropagation();
    },

    handleSaveClick: function (event) {
        // Clicking Save -> create the font size
        event.preventDefault();
        this.doFormSave();
    },

    handleCloseClick: function (event) {
        // Click Close -> close the form
        event.preventDefault();
        this.doFormCancel();
    },

    refresh: function() {
        setTimeout(()=>{
            var footerContent = this.base.elements[0].getElementsByClassName("footer-content")[0];
        
            if(footerContent){
                this._gestionarClaseNoFooter(footerContent);
            }
        },0);
    },
    pieSize() {
        return this._mb2Cm(this.marginClass) || 1;
    },
    changeOptions: function(pies){
        var self = this;
        var doc = self.document;
        pies.unshift({   name: '', content: ''   });
        self.pies = [{name:"", content:""},{name:'Pie por defecto', content:''}];
        var form = this.getForm();
        var select = form.getElementsByClassName("medium-editor-toolbar-select")[0];
        Array.from(select.childNodes).forEach(node => {node.remove();});
		pies.forEach(pie => {
		if(!pie.valores) return;
                pie.valores.forEach(optionRes => {
                var content = optionRes.content || optionRes.nombre || '';
                console.log('Procesando opción:', optionRes.valor, 'con contenido:', content);
                self.pies.push({name:optionRes.valor, content: content});
            })
        });
        self.pies.forEach(optionRes => {
            var option = doc.createElement('option');
            option.innerHTML = optionRes.name;
            option.value = optionRes.content;
            select.appendChild(option);
        });
    },
    setInitialContent: function (content) {
        var footerContent = content.getElementsByClassName("footer-content")[0];
        if(footerContent){
            this._gestionarClaseNoFooter(footerContent);
            this._gestionarMargen(footerContent);
        }
    },

    _gestionarMargen: function(contenedor){
        var hijos = Array.from(contenedor.childNodes).filter(node => node.nodeName != "#text"),
            footer = hijos.length ? hijos[0] : null;
        if(!footer){
            return;
        }
        var clases = footer.classList,
            marginClasses = Array.from(clases).filter(clase => clase.match(/mb-\d+/)),
            marginClass = marginClasses.length ? marginClasses[0] : null;
        if(!marginClass){
            this.marginClass = null;
        } else {
            this.marginClass = marginClass;
        }
    },
    _mb2Cm: function(mbClass){
        return mbClass ? mbClass.replace(/mb-(\d+)/, "$1")/10 : 1;
    }

});
export default Pie;